module.exports = __webpack_public_path__ + "static/icons/icon-new-tab-0dc40300ea166f30e890c7fbaabd235d.svg";